/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class Initiator {
  /**
  * The ID of the initiator
  */
  'id': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Initiator.attributeTypeMap;
  }

  public constructor() {
  }
}

